import { render, staticRenderFns } from "./CommentsOnLessonsListPage.vue?vue&type=template&id=f72a03b8&scoped=true&"
import script from "./CommentsOnLessonsListPage.vue?vue&type=script&lang=ts&"
export * from "./CommentsOnLessonsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsOnLessonsListPage.vue?vue&type=style&index=0&id=f72a03b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72a03b8",
  null
  
)

export default component.exports